export var ConselhoClasseEnum;
(function (ConselhoClasseEnum) {
    ConselhoClasseEnum["CRT_01"] = "CRT_01";
    ConselhoClasseEnum["CREA_MT"] = "CREA_MT";
    ConselhoClasseEnum["CAU_BR"] = "CAU_BR";
})(ConselhoClasseEnum || (ConselhoClasseEnum = {}));
(function (ConselhoClasseEnum) {
    var mapDescricao = new Map([
        [ConselhoClasseEnum.CRT_01, 'Conselho Regional dos Técnicos Industriais'],
        [ConselhoClasseEnum.CREA_MT, 'Conselho Regional de Engenharia e Agronomia'],
        [ConselhoClasseEnum.CAU_BR, 'Conselho de Arquitetura e Urbanismo'],
    ]);
    var mapSigla = new Map([
        [ConselhoClasseEnum.CRT_01, 'CRT'],
        [ConselhoClasseEnum.CREA_MT, 'CREA'],
        [ConselhoClasseEnum.CAU_BR, 'CAU'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    ConselhoClasseEnum.getDescricao = getDescricao;
    function getSigla(key) {
        return mapSigla.get(key);
    }
    ConselhoClasseEnum.getSigla = getSigla;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    ConselhoClasseEnum.getOptions = getOptions;
})(ConselhoClasseEnum || (ConselhoClasseEnum = {}));
